import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Exam Vouchers|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryExamVouchers';
export type SPCandidateHistoryExamVouchersLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}LabelCode`
	| `${LocNameStart}LabelExamName`
	| `${LocNameStart}LabelRecordId`
	| `${LocNameStart}LabelDiscountCode`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelInactive`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelMaxAttempts`
	| `${LocNameStart}LabelMaxRetakes`
	| `${LocNameStart}LabelNetAcademyId`;

export const spCandidateHistoryExamVouchersLocs: LocDefs<SPCandidateHistoryExamVouchersLocNames> = {
	SPCandidateHistoryExamVouchersTitle: {
		defaultValue: 'Exam Vouchers/Discounts Details',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelCode: {
		defaultValue: 'Code',
		description: 'Column heading for: Code.',
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.Code',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelExamName: {
		defaultValue: 'Exam Name',
		description: 'Column heading for: Exam Name.',
		displayPath: `${pathStart}Exam Name`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.ExamName',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelRecordId: {
		defaultValue: 'Record ID',
		description: 'Column heading for: Record ID.',
		displayPath: `${pathStart}Record ID`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.RecordId',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelDiscountCode: {
		defaultValue: 'Discount Code',
		description: 'Column heading for: Discount Code.',
		displayPath: `${pathStart}Discount Code`,
		displayType: 'Label',
		legacyName:
			'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.DiscountCode',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelActiveDate: {
		defaultValue: 'Active',
		description: 'Column heading for: Active.',
		displayPath: `${pathStart}Active`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.Active',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelInactive: {
		defaultValue: 'Inactive',
		description: 'Column heading for: Inactive.',
		displayPath: `${pathStart}Inactive`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.Inactive',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelMaxAttempts: {
		defaultValue: 'Max Attempts',
		description: 'Column heading for: Max Attempts.',
		displayPath: `${pathStart}Max Attempts`,
		displayType: 'Label',
		legacyName:
			'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.MaxAttempts',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelMaxRetakes: {
		defaultValue: 'Max Retakes',
		description: 'Column heading for: Max Retakes.',
		displayPath: `${pathStart}Max Retakes`,
		displayType: 'Label',
		legacyName:
			'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.MaxRetakes',
		...sharedProperties,
	},
	SPCandidateHistoryExamVouchersLabelNetAcademyId: {
		defaultValue: 'Net Academy ID',
		description: 'Column heading for: Net Academy ID.',
		displayPath: `${pathStart}Net Academy ID`,
		displayType: 'Label',
		legacyName:
			'Exam.CertMetricsVouchers/Candidates.ExamVoucherHistory.ColumnHeading.NetAcademyId',
		...sharedProperties,
	},
};

export type SPCandidateHistoryExamVouchersLocType = LocMap<SPCandidateHistoryExamVouchersLocNames>;
